/**
 * Chip colors used in renderHTML output for email client compatibility.
 * Email clients do not support CSS variables or theme tokens, so these
 * must be hardcoded rgba values matching the existing Quill chip styling.
 */
export const CHIP_INLINE_COLORS = {
  backgroundColor: "rgba(234, 237, 255, 1)",
  borderColor: "rgba(214, 220, 255, 1)",
  textColor: "rgba(60, 11, 193, 1)",
} as const;

/** CSS class name for chip elements (shared with legacy Quill format) */
export const CHIP_CLASS_NAME = "dd-template-chip";

/** Default editor configuration */
export const EDITOR_DEFAULTS = {
  placeholder: "Type something...",
  minHeight: "150px",
  maxHeight: "500px",
  toolbarPosition: "top" as const,
} as const;

/** Suggestion trigger characters for variable chip insertion */
export const VARIABLE_TRIGGER = "{{";

/** Maximum number of suggestion results to show */
export const MAX_SUGGESTION_RESULTS = 20;
